import React from 'react';
import { NavLink } from 'react-router-dom';
import classes from './index.module.css';
import { Drawer, IconButton, Hidden, Button } from '@material-ui/core';
import { MenuRounded } from '@material-ui/icons';
// import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { withRouter } from '../../helpers/withRouter';
import clsx from 'clsx';

// const StyledButton = withStyles({
//   root: {
//     background: '#2955E9',
//     borderRadius: 30,
//     border: '2px solid #2955E9',
//     color: 'white',
//     height: 35,
//     padding: '0 30px',
//     '&:hover': {
//       background: 'white',
//       color: '#2955E9',
//       border: '2px solid #2955E9',
//     }
//   },
//   label: {
//     textTransform: 'capitalize',
//   },
// })(Button);

const links = [
  { text: 'home', link: '', id: 'home' },
  { text: 'pricing', link: `/pricing/publish`, id: 'pricing' },
  // { text: 'faq', link: '/faq' },
  // { text: 'about', link: '/about' },
  // { text: 'blogs', link: '/blogs' },
]
class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
      scrollPos: 0,
      showMenu: false,
    };
  }

  openMenu = () => {
    this.setState({
      showMenu: true
    })
  }

  closeMenu = () => {
    this.setState({
      showMenu: false
    })
  }


  render() {
    const { t, i18n, location } = this.props;

    const list = (
      <>
        {links.map((link, idx) => {
          const href = `/${i18n.language}${link.link}`;
          return (
            <li
              onClick={this.closeMenu}
              key={idx}
              className={clsx(
                classes.listItem,
                location.pathname.split('/').slice(0, 3).join('/') === href.split('/').slice(0, 3).join('/') && classes.activeItem
              )}
            >
              {/* {console.log( location.pathname.split('/').slice(0, 3).join('/'), href.split('/').slice(0, 3).join('/'))} */}
              <NavLink
                to={{
                  pathname: href
                }}
                className={classes.link}
                id={link.id}
              >
                {t(link.text)}
              </NavLink>
            </li>
          )
        })}
        {/* <li>
          <Select
            onChange={(e) => this.handleChange(e)}
            value={i18n.language}
            inputProps={{ MenuProps: { disableScrollLock: true } }}
          >
            <MenuItem value="en">
              <ListItemText>English</ListItemText>
            </MenuItem>
            <MenuItem value="es">
              <ListItemText>Spanish</ListItemText>
            </MenuItem>
            <MenuItem value="fr">
              <ListItemText>French</ListItemText>
            </MenuItem>
          </Select>
        </li> */}
        {/* <li>
          <StyledButton>
            {t('login')}
          </StyledButton>
        </li> */}
      </>
    );

    return (
      <>
        <div className={
          clsx(
            classes.header,
            this.state.show ? classes.active : classes.hidden
          )
        }>
          <img className={classes.logo} src={`https://images.postplan.io/logo.png`} alt="logo" />

          <ul className={classes.topBarList}>
            {list}
            {/* <Hidden smDown>
            </Hidden> */}
            {/* <Hidden mdUp>
              <IconButton onClick={this.openMenu}>
                <MenuRounded fontSize="large" />
              </IconButton>
            </Hidden> */}
          </ul>

          <div style={{ position: 'relative' }}>
            <Button color="primary" variant="contained" style={{ background: '#022aaf' }} onClick={() => window.open('https://app.postplan.io')}>
              Login
            </Button>
          </div>
        </div>

        {/* <Drawer open={this.state.showMenu} onClose={this.closeMenu}>
          <ul className={classes.menuList}>
            {list}
          </ul>
        </Drawer> */}
      </>
    )
  }
}

export default withRouter(withTranslation(['common'])(Navbar));